import { Popup, Icon, List } from "semantic-ui-react";
import { CheckIcon, WarningIcon } from "../index";

const styles = {
	errorPopup: {},
};

const PrescriptionsTab = ({ t, disabled, prescription }) => {
	return (
		<Popup
			position="bottom center"
			disabled={prescription.status && Object.keys(prescription.warnings).length === 0 && Object.keys(prescription.othersWarnings).length === 0}
			style={styles.errorPopup}
			offset="7px, 0"
			trigger={
				<span>
					<Icon name="file alternate" size="small" /> {t("subMenu.prescriptions")}
					{!disabled &&
						(prescription.status && Object.keys(prescription.warnings).length === 0 && Object.keys(prescription.othersWarnings).length === 0 ? (
							<CheckIcon />
						) : (
							<WarningIcon />
						))}
				</span>
			}
		>
			<Popup.Header>
				{Object.keys(prescription.othersWarnings).length === 0 ? t("subMenu.missingInformation") : t("subMenu.toBeCorrected")}
			</Popup.Header>
			<Popup.Content>
				{Object.keys(prescription.errors).length === 0 &&
					Object.keys(prescription.warnings).length === 0 &&
					Object.keys(prescription.othersWarnings).length === 0 &&
					"Aucune prescription"}
				{Object.keys(prescription.errors).length > 0 && (
					<List bulleted>
						{Object.keys(prescription.errors).map((key) => (
							<List.Item key={key}>
								{t("subMenu.missingInformationContent", { key: key })}
								<List.List>
									{prescription.errors[key].map((error, index) => (
										<List.Item key={`prescription-error-${key}-${index}`}>{error}</List.Item>
									))}
								</List.List>
							</List.Item>
						))}
					</List>
				)}
				{Object.keys(prescription.warnings).length > 0 && (
					<List bulleted>
						{Object.keys(prescription.warnings).map((key) => (
							<List.Item key={key}>
								{t("subMenu.missingImportantInformation", { key: key })}
								<List.List>
									{prescription.warnings[key].map((error, index) => (
										<List.Item key={`prescription-warning-${key}-${index}`}>{error}</List.Item>
									))}
								</List.List>
							</List.Item>
						))}
					</List>
				)}
				{Object.keys(prescription.othersWarnings).length > 0 && (
					<List bulleted>
						{Object.keys(prescription.othersWarnings).map((key) => (
							<List.Item key={key}>{prescription.othersWarnings[key]}</List.Item>
						))}
					</List>
				)}
			</Popup.Content>
		</Popup>
	);
};

export default PrescriptionsTab;
